// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA22ZkMcctNBu4I0EZkRcHlNDwvRG6LLAQ",
  authDomain: "triple-freezer.firebaseapp.com",
  databaseURL: 'https://triple-freezer-default-rtdb.europe-west1.firebasedatabase.app/',
  projectId: "triple-freezer",
  storageBucket: "triple-freezer.appspot.com",
  messagingSenderId: "471051501479",
  appId: "1:471051501479:web:9b6c5f59cc90b20093c082",
  measurementId: "G-0MLY49W085"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export Firebase services
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);

// Local development against the Firebase emulators.
//
// Strictly opt-in: without REACT_APP_USE_EMULATOR=true this block does nothing
// and the app talks to production exactly as before. Needed to work on the
// broadcast screen, which can only be judged with a match actually in progress
// — and nobody should be inventing live matches in the production tournament to
// see what a dice animation looks like.
//
//   REACT_APP_USE_EMULATOR=true npm start
if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  // eslint-disable-next-line no-console
  console.warn('[firebase] Using LOCAL EMULATORS — no production data is being read or written.');
  connectDatabaseEmulator(database, '127.0.0.1', 9000);
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
}

// Event logging functions
export const logSignUpEvent = () => {
  // Check if analytics consent is granted
  if (!hasAnalyticsConsent()) {
    console.log('[Analytics] Skipping sign_up event - no consent');
    return;
  }
  
  console.log('[Analytics] Logging sign_up event');
  logEvent(analytics, 'sign_up', {
    method: 'Email',
  });
};

export const logLoginEvent = () => {
  // Check if analytics consent is granted
  if (!hasAnalyticsConsent()) {
    console.log('[Analytics] Skipping login event - no consent');
    return;
  }
  
  console.log('[Analytics] Logging login event');
  logEvent(analytics, 'login', {
    method: 'Email',
  });
};

export const logGamePlayedEvent = (gameName: string) => {
  // Check if analytics consent is granted
  if (!hasAnalyticsConsent()) {
    console.log('[Analytics] Skipping game_played event - no consent');
    return;
  }
  
  console.log('[Analytics] Logging game_played event:', gameName);
  logEvent(analytics, 'game_played', {
    game_name: gameName,
  });
};

export const logDiceCalculatedEvent = (gameName: string, diceValue: number) => {
  // Check if analytics consent is granted
  if (!hasAnalyticsConsent()) {
    console.log('[Analytics] Skipping dice_calculated event - no consent');
    return;
  }
  
  console.log('[Analytics] Logging dice_calculated event:', gameName, diceValue);
  logEvent(analytics, 'dice_calculated', {
    game_name: gameName,
    dice_value: diceValue,
  });
};

export const logGameFinishedEvent = (gameName: string, winner: string, finalScore: number) => {
  // Check if analytics consent is granted
  if (!hasAnalyticsConsent()) {
    console.log('[Analytics] Skipping game_finished event - no consent');
    return;
  }
  
  console.log('[Analytics] Logging game_finished event:', gameName, winner, finalScore);
  logEvent(analytics, 'game_finished', {
    game_name: gameName,
    winner: winner,
    final_score: finalScore,
  });
};

export const logTripleFreezeEvent = (playerName: string) => {
  // Check if analytics consent is granted
  if (!hasAnalyticsConsent()) {
    console.log('[Analytics] Skipping triple_freeze event - no consent');
    return;
  }
  
  console.log('[Analytics] Logging triple_freeze event:', playerName);
  logEvent(analytics, 'triple_freeze', {
    player_name: playerName,
  });
};

export const logLostAllPointsEvent = (playerName: string) => {
  // Check if analytics consent is granted
  if (!hasAnalyticsConsent()) {
    console.log('[Analytics] Skipping lost_all_points event - no consent');
    return;
  }
  
  console.log('[Analytics] Logging lost_all_points event:', playerName);
  logEvent(analytics, 'lost_all_points', {
    player_name: playerName,
  });
};

export const logTriplaTriplatEvent = (playerName: string) => {
  // Check if analytics consent is granted
  if (!hasAnalyticsConsent()) {
    console.log('[Analytics] Skipping tripla_triplat event - no consent');
    return;
  }
  
  console.log('[Analytics] Logging tripla_triplat event:', playerName);
  logEvent(analytics, 'tripla_triplat', {
    player_name: playerName,
  });
};

export const logTriplatEvent = (playerName: string) => {
  // Check if analytics consent is granted
  if (!hasAnalyticsConsent()) {
    console.log('[Analytics] Skipping triplat event - no consent');
    return;
  }
  
  console.log('[Analytics] Logging triplat event:', playerName);
  logEvent(analytics, 'triplat', {
    player_name: playerName,
  });
};

// Helper function to check analytics consent
const hasAnalyticsConsent = (): boolean => {
  try {
    const cookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('triple_freezer_consent='));
    
    if (cookie) {
      const value = cookie.split('=')[1];
      const consent = JSON.parse(decodeURIComponent(value));
      return consent?.analytics === true;
    }
  } catch (error) {
    console.error('Error checking analytics consent:', error);
  }
  return false;
};